var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 11.1667H1.83333V1.83333H6.5V0.5H1.83333C1.09333 0.5 0.5 1.1 0.5 1.83333V11.1667C0.5 11.9 1.09333 12.5 1.83333 12.5H11.1667C11.9 12.5 12.5 11.9 12.5 11.1667V6.5H11.1667V11.1667ZM7.83333 0.5V1.83333H10.2267L3.67333 8.38667L4.61333 9.32667L11.1667 2.77333V5.16667H12.5V0.5H7.83333Z",
    fill: "#005996"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLink);
export default __webpack_public_path__ + "static/media/icn_link.1d9b183e98efa942f0bee47b0f3fcf60.svg";
export { ForwardRef as ReactComponent };